import { RippleAnimation } from "@dashboard/ripples/components/RippleAnimation";
import { useRippleStorage } from "@dashboard/ripples/hooks/useRipplesStorage";
import type { Ripple as RippleModel } from "@dashboard/ripples/types";
import { Box, Button, Text, Tooltip } from "@saleor/macaw-ui-next";
import { useIntl } from "react-intl";

/**
 * 2026-10-18 KST: Saleor 새 기능 알림 힌트(파란 점)를 대시보드 전체에서 숨긴다.
 * 이전 Saleor 사용자를 위한 변경 소식이라 이 쇼핑몰 운영자에게는 맞지 않고,
 * 업스트림 병합 때마다 영어 힌트가 새로 들어온다. 다시 켜려면 `Ripple = RippleTooltip` 으로 되돌린다.
 */
export const Ripple = (_props: { model: RippleModel }): null => null;

export const RippleTooltip = (props: { model: RippleModel }) => {
  const content = props.model.content.contextual;
  const isPlainString = typeof content === "string";
  const intl = useIntl();
  const { setFirstSeenFlag, getShouldShow, setManuallyHidden } = useRippleStorage();

  if (!getShouldShow(props.model)) {
    return null;
  }

  return (
    <Tooltip
      onOpenChange={() => {
        setFirstSeenFlag(props.model);
      }}
    >
      <Tooltip.Trigger>
        <Box>
          <RippleAnimation cursor="pointer" />
        </Box>
      </Tooltip.Trigger>
      <Tooltip.Content align="start" side="bottom">
        <Tooltip.Arrow />
        <Box __maxWidth="320px">
          {/* 2026-09-28 KST: 하드코딩된 "Hint" 제목을 번역 가능한 메시지로 */}
          <Tooltip.ContentHeading>
            {intl.formatMessage({
              defaultMessage: "Hint",
              id: "MFH0Fr",
              description: "ripple tooltip heading",
            })}
          </Tooltip.ContentHeading>
          {/* 2026-10-01 KST: 힌트 본문을 기본(14px)보다 한 단계 작은 12px 로 */}
          <Box marginBottom={4}>{isPlainString ? <Text size={3}>{content}</Text> : content}</Box>
          <Box display="flex" justifyContent="flex-end" gap={2}>
            {props.model.actions?.map((rippleAction, index) => {
              if (rippleAction.href) {
                return (
                  <Button
                    key={index}
                    size="small"
                    variant="tertiary"
                    onClick={e => {
                      e.preventDefault();
                      e.stopPropagation();
                      setManuallyHidden(props.model);
                      window.open(rippleAction.href, "_blank", "noopener,noreferrer");
                    }}
                  >
                    {intl.formatMessage(rippleAction.label)}
                  </Button>
                );
              }

              return (
                <Button
                  size="small"
                  key={index}
                  variant="tertiary"
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();

                    setManuallyHidden(props.model);

                    rippleAction.onClick?.();
                  }}
                >
                  {intl.formatMessage(rippleAction.label)}
                </Button>
              );
            })}
            <Button
              size="small"
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();

                setManuallyHidden(props.model);
              }}
            >
              {intl.formatMessage({
                defaultMessage: "OK",
                id: "kAEQyV",
              })}
            </Button>
          </Box>
        </Box>
      </Tooltip.Content>
    </Tooltip>
  );
};
